export default "__VITE_ASSET__b8b57988__"